import { render, staticRenderFns } from "./barXChart.vue?vue&type=template&id=1a57e5ca&scoped=true"
import script from "./barXChart.vue?vue&type=script&lang=js"
export * from "./barXChart.vue?vue&type=script&lang=js"
import style0 from "./barXChart.vue?vue&type=style&index=0&id=1a57e5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a57e5ca",
  null
  
)

export default component.exports